import { createTheme, Theme, ThemeProvider } from '@mui/material'
import { merge } from 'lodash'
import { useEffect, useState } from 'react'

import theme from '~/app/providers/ui/theme'
import LoadingWithBackdrop from '~/components/loadingWithBackdrop'
import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import { TBrandColor } from '~/features/partners/models'
import {
  convertBrandColorsToPaletteObject,
  isArrayOfTypeTBrandColor,
} from '~/features/partners/utils'

function PartnerThemeWrapper({ children }: { children: React.ReactNode }) {
  const { partner, isLoading } = usePartnerCentralized()

  const [partnerTheme, setPartnerTheme] = useState<Theme | undefined>()

  const hasBrandColors = isArrayOfTypeTBrandColor(partner.brandUIColors)

  useEffect(() => {
    if (hasBrandColors) {
      const customColors = convertBrandColorsToPaletteObject(
        partner.brandUIColors as TBrandColor[],
      )

      setPartnerTheme(
        createTheme(
          merge({ ...theme, palette: { ...theme.palette } }, customColors),
        ),
      )
      return
    }

    setPartnerTheme(undefined)
  }, [hasBrandColors, partner.brandUIColors])

  if (isLoading || (hasBrandColors && !partnerTheme)) {
    return <LoadingWithBackdrop show />
  }

  return <ThemeProvider theme={partnerTheme ?? theme}>{children}</ThemeProvider>
}
export default PartnerThemeWrapper
